import { MdSwapVert, MdArrowDownward, MdArrowUpward } from '../node_modules/react-icons/md/index.js';

function arrToState() {
  let args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const o = {};
  for (const s of args) {
    o[s] = true;
  }
  return o;
}
function stateToArr(args) {
  return Object.entries(args).filter(_ref => {
    let [, v] = _ref;
    return v;
  }).map(_ref2 => {
    let [k] = _ref2;
    return k;
  });
}
function xor() {
  for (var _len = arguments.length, vals = new Array(_len), _key = 0; _key < _len; _key++) {
    vals[_key] = arguments[_key];
  }
  return vals.filter(x => x).length === 1;
}
function nextSortDir(dir) {
  if (dir === 'unset') {
    return 'asc';
  }
  if (dir === 'asc') {
    return 'desc';
  }
  return 'unset';
}
const sortIcons = {
  asc: MdArrowUpward,
  desc: MdArrowDownward,
  unset: MdSwapVert
};

// TODO(chrisw): 'single'

export { arrToState, nextSortDir, sortIcons, stateToArr, xor };
